import { render, staticRenderFns } from "./InvoiceTableDesktop.vue?vue&type=template&id=754961a3&scoped=true"
import script from "./InvoiceTableDesktop.vue?vue&type=script&lang=js"
export * from "./InvoiceTableDesktop.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=754961a3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754961a3",
  null
  
)

export default component.exports